import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Faltan las variables de entorno de Supabase');
}

export const supabase = createClient(supabaseUrl || '', supabaseAnonKey || '');

// Tipos de la base de datos
export interface Profile {
  id: string;
  email: string;
  full_name: string;
  age: number;
  weight: number;
  height: number;
  gender: string;
  fitness_level: string;
  goal: string;
  medical_conditions: string[];
  created_at: string;
  updated_at: string;
}

export interface WorkoutSession {
  id: string;
  user_id: string;
  workout_id: string;
  workout_name: string;
  duration: number;
  calories_burned: number;
  exercises_completed: number;
  total_exercises: number;
  completed_at: string;
  notes?: string;
}

export interface ExerciseProgress {
  id: string;
  user_id: string;
  exercise_id: string;
  exercise_name: string;
  sets: number;
  reps: number;
  weight: number;
  duration?: number;
  notes?: string;
  recorded_at: string;
}

export interface NutritionPlan {
  id: string;
  user_id: string;
  plan_type: string;
  daily_calories: number;
  protein_grams: number;
  carbs_grams: number;
  fats_grams: number;
  active: boolean;
  created_at: string;
}

export interface MealLog {
  id: string;
  user_id: string;
  meal_type: string;
  meal_name: string;
  calories: number;
  protein: number;
  carbs: number;
  fats: number;
  logged_at: string;
}

export interface BodyMeasurement {
  id: string;
  user_id: string;
  weight: number;
  body_fat_percentage?: number;
  muscle_mass?: number;
  chest?: number;
  waist?: number;
  hips?: number;
  arms?: number;
  thighs?: number;
  measured_at: string;
}

export interface Achievement {
  id: string;
  user_id: string;
  achievement_type: string;
  achievement_name: string;
  description?: string;
  unlocked_at: string;
}
